import React, { useEffect, useState } from "react";
import axios from "../../../lib/axios";
import ViewStudent from "./AdminViewCost";
import "./AdCost.scss";

import { Delete } from "@mui/icons-material";
import TechAddLesson from "./AdminAddCost";
import TechUpdateLesson from "./AdminUpdateCost";
import { useNavigate } from "react-router-dom";
import AdNavbar from "../AdNavbar/AdNavbar";
import AdminViewCostInner from "./AdminViewCostInner";
import Pagination from "@mui/material/Pagination"; // Import Pagination
import Stack from "@mui/material/Stack"; // Impo

export default function AdCost() {
  const useAuth = window.localStorage;
  const navigate = useNavigate();
  const Token = useAuth.getItem("accessToken");
  const [costs, setCosts] = useState();
  const [change, setChange] = useState(false);
  const [page, setPage] = useState(1); // Current page state
  const [totalPages, setTotalPages] = useState(1); // Total pages state
  const [limit] = useState(10); // Number of items per page

  const config = {
    headers: {
      Authorization: Token,
    },
  };

  useEffect(() => {
    axios
      .get(`/payment/expenses?page=${page}&limit=${limit}`, config)
      .then((response) => {
        console.log(response.data);
        setCosts(response.data.expenses);
        setTotalPages(response.data.count < limit ? 1 : Math.ceil(response.data.count / limit)); // Assuming your API returns the total number of pages
      })
      .catch((err) => {
        if (err.response === 401) {
          navigate("/logout");
        }
        console.log(err);
      });
  }, [page]);

  const deleteLesson = (id) => {
    if (confirm("O'chirishni istaysizmi?")) {
      axios
        .delete(`/payment/expenses/${id}`, config)
        .then(() => {
          window.location.reload();
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const toggleAction = (e) => {
    const actionBody = e.target.nextSibling;
    console.log(actionBody, "actionBody");
    if (actionBody.style.display === "block") {
      actionBody.style.display = "none";
    } else {
      actionBody.style.display = "block";
    }
  };

  const handlePageChange = (event, value) => {
    setPage(value); // Update the page state when user changes the page
  };

  return (
    <>
      <AdNavbar />
      <main className="mainPage">
        {/* {costs === undefined ? (
          <section className="mygroup-section tech-lesson-section">

          </section>
        ) : ( */}
          <section className="mygroup-section tech-lesson-section ad-teacher">
            <div className="container">
              <div className="mygroup">
                <table className="mygroup__table desktop">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Sana</th>
                      <th>Krim</th>
                      <th>Chiqim</th>
                      <th className="add-wrapper">
                        <TechAddLesson />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {costs &&
                      costs.map((item, index) => (
                        <tr key={index} id={item.id}>
                          <td>{index + 1}</td>
                          <td id="lessonName">
                            <p onClick={() => setChange(!change)}>
                              {item.cost_date.split("T")[0] + " / " + item.cost_date.split("T")[1].split("Z")[0]}
                            </p>
                          </td>
                          <td>
                            <p>{item.incoming_amount}</p>
                          </td>
                          <td>
                            <p>{item.out_coming_amount}</p>
                          </td>
                          <td className="add-wrapper">
                            <ViewStudent data={item} />
                            <TechUpdateLesson data={item} />
                            <button
                              className="btn-delete"
                              onClick={() => deleteLesson(item.id)}
                              style={{ color: "crimson" }}
                            >
                              <Delete />
                            </button>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>

                <div className="mygroup__table mobile">
                  <div className="mygroup__table-head">
                    <div className="">#</div>
                    <div className="">Sana</div>
                    <TechAddLesson />
                  </div>
                  <div className="mygroup__table-body">
                    {costs &&
                      costs.map((item, index) => (
                        <div key={index} className="mygroup__table-body--item">
                          <div className=""><p>{index + 1}</p></div>
                          <div className="group-name">
                          <p onClick={() => setChange(!change)}>
                              {item.cost_date.split("T")[0] + " / " + item.cost_date.split("T")[1].split("Z")[0]}
                            </p>
                          </div>
                          <div>
                              <button className="btn-action"
                                onClick={ toggleAction}>
                                  •••
                              </button>
                              <div className="ad-teacher-action-body">
                                <AdminViewCostInner data={item} />
                                <TechUpdateLesson data={item} />
                                <button
                                  className="btn-delete"
                                  onClick={() => deleteLesson(item.id)}
                                  style={{ color: "crimson" }}
                                >
                                  <Delete />
                                </button>
                              </div>
                            </div>
                        </div>
                      ))}
                  </div>
                </div>
                <Stack spacing={2} alignItems="center" marginTop="20px">
                  <Pagination
                    count={totalPages}
                    page={page}
                    onChange={handlePageChange}
                    color="secondary"
                    variant="outlined"
                    shape="rounded"
                  />
                </Stack>
              </div>
            </div>
          </section>
        {/* )} */}
      </main>
    </>
  );
}
